import { CheckCircle2, ChefHat, Bath, Sofa, SquareAsterisk } from 'lucide-react';

const CardItem = ({ text }) => (
  <li className="flex items-start gap-2">
    <CheckCircle2 size={14} className="text-[#4CAF50] flex-shrink-0 mt-0.5" />
    <span>{text}</span>
  </li>
);

const KitchenCard = () => (
  <div className="bg-white rounded-xl p-5 sm:p-6 border border-gray-100 shadow-sm text-center">
    <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4 bg-[#E8F5E9]">
      <ChefHat size={24} className="text-[#2E7D32]" />
    </div>
    <h3 className="font-bold text-[#0F172A] mb-3 text-sm sm:text-base uppercase tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>Kitchen</h3>
    <ul className="text-[#555] text-xs sm:text-sm space-y-1.5 text-left">
      <CardItem text="Exterior of appliances" />
      <CardItem text="Countertops & backsplash" />
      <CardItem text="Cabinet fronts" />
      <CardItem text="Sink scrubbed & polished" />
      <CardItem text="Floors vacuumed & mopped" />
      <CardItem text="Detail dusting" />
    </ul>
  </div>
);

const BathroomCard = () => (
  <div className="bg-white rounded-xl p-5 sm:p-6 border border-gray-100 shadow-sm text-center">
    <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4 bg-[#E8F5E9]">
      <Bath size={24} className="text-[#2E7D32]" />
    </div>
    <h3 className="font-bold text-[#0F172A] mb-3 text-sm sm:text-base uppercase tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>Bathroom</h3>
    <ul className="text-[#555] text-xs sm:text-sm space-y-1.5 text-left">
      <CardItem text="Shower & tub scrubbed" />
      <CardItem text="Toilet sanitized" />
      <CardItem text="Mirrors polished" />
      <CardItem text="Vanity cleaned" />
      <CardItem text="Tile attention" />
      <CardItem text="Floors cleaned" />
    </ul>
  </div>
);

const BedroomCard = () => (
  <div className="bg-white rounded-xl p-5 sm:p-6 border border-gray-100 shadow-sm text-center">
    <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4 bg-[#E8F5E9]">
      <Sofa size={24} className="text-[#2E7D32]" />
    </div>
    <h3 className="font-bold text-[#0F172A] mb-3 text-sm sm:text-base uppercase tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>Bedrooms & Living</h3>
    <ul className="text-[#555] text-xs sm:text-sm space-y-1.5 text-left">
      <CardItem text="Dusting surfaces" />
      <CardItem text="Baseboards" />
      <CardItem text="Floors" />
      <CardItem text="Window sills" />
      <CardItem text="Ceiling fan dusting" />
      <CardItem text="General detail cleaning" />
    </ul>
  </div>
);

const WindowCard = () => (
  <div className="bg-white rounded-xl p-5 sm:p-6 border border-gray-100 shadow-sm text-center">
    <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4 bg-[#E8F5E9]">
      <SquareAsterisk size={24} className="text-[#2E7D32]" />
    </div>
    <h3 className="font-bold text-[#0F172A] mb-3 text-sm sm:text-base uppercase tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>Windows</h3>
    <ul className="text-[#555] text-xs sm:text-sm space-y-1.5 text-left">
      <CardItem text="Interior windows" />
      <CardItem text="Exterior windows" />
      <CardItem text="Tracks & sills" />
      <CardItem text="Streak-free shine" />
      <CardItem text="Safe & effective methods" />
    </ul>
  </div>
);

export const CleaningCards = () => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
    <KitchenCard />
    <BathroomCard />
    <BedroomCard />
    <WindowCard />
  </div>
);
